import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingCard = ({ plan, billingCycle, isPopular }) => {
  const getPrice = () => {
    if (plan?.type === 'desktop') {
      return plan?.price;
    }
    return billingCycle === 'monthly' ? plan?.monthlyPrice : plan?.yearlyPrice;
  };

  const getPriceLabel = () => {
    if (plan?.type === 'desktop') {
      return 'per month';
    }
    return billingCycle === 'monthly' ? 'per month' : 'per year';
  };

  return (
    <div
      className={`relative flex flex-col rounded-2xl border transition-smooth hover:-translate-y-2 ${
        isPopular
          ? 'border-primary bg-card shadow-purple-lg'
          : 'border-border bg-card shadow-purple'
      }`}
    >
      {isPopular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary px-4 py-1.5 text-xs md:text-sm font-medium text-primary-foreground shadow-purple">
            <Icon name="Star" size={14} color="currentColor" strokeWidth={2} />
            Most Popular
          </span>
        </div>
      )}
      <div className="p-6 md:p-8">
        <div className="mb-6">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-2">
            {plan?.name}
          </h3>
          <p className="font-body text-sm md:text-base text-muted-foreground">
            {plan?.description}
          </p>
        </div>

        <div className="mb-6">
          <div className="flex items-baseline gap-2">
            <span className="font-heading text-4xl md:text-5xl font-bold text-foreground">
              ₦{getPrice()?.toLocaleString()}
            </span>
          </div>
          <p className="font-body text-sm text-muted-foreground mt-1">
            {getPriceLabel()}
          </p>
        </div>

        <a
          href={plan?.ctaLink}
          target="_blank"
          rel="noopener noreferrer"
          className="block mb-6"
        >
          <Button
            variant={isPopular ? 'default' : 'outline'}
            size="lg"
            fullWidth
          >
            {plan?.ctaText}
          </Button>
        </a>

        <div className="space-y-4">
          <p className="font-body text-sm font-medium text-foreground">
            {plan?.featuresTitle}
          </p>
          <ul className="space-y-3">
            {plan?.features?.map((feature, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icon
                  name="Check"
                  size={20}
                  color="var(--color-success)"
                  strokeWidth={2}
                  className="flex-shrink-0 mt-0.5"
                />
                <span className="font-body text-sm md:text-base text-foreground">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;